export const BASE_URL = 'operonda-api';

export const PATHS = {
  BASE_URL,
};
